import React, {Component} from 'react';
import {formatSecondsSmall} from '../utils/date';
import {numberFormat} from '../utils/number';

export default class StatisticsHeadingCounts extends Component {
    render() {
        const {data} = this.props;

        const totalCount = data.competitions_total_count || 0;
        const totalBudget = data.competitions_total_budget || 0.0;
        const totalAwarded = data.competitions_total_awarded || 0.0;
        const avgCompletionTime = data.competitions_avg_completion_time
            ? formatSecondsSmall(data.competitions_avg_completion_time)
            : '-';
        const contractsCount = data.contracts_count || 0;

        return (
            <div className="statistics-counts row tile_count">
                <div className="animated flipInY col-md-6 col-lg-5ths tile_stats_count">
                    <a href="#" className="right">
                        <div className="count">
                            {numberFormat(totalCount, 0, '', '.')}
                        </div>
                        <div className="count_top">{window.__js_dashboard.competitions_total_count}</div>
                    </a>
                </div>
                <div className="animated flipInY col-md-6 col-lg-5ths tile_stats_count">
                    <a href="#" className="right">
                        <div className="count">
                            {numberFormat(totalBudget, 2, ',', '.')} €
                        </div>
                        <div className="count_top">{window.__js_dashboard.total_budget_amount}</div>
                    </a>
                </div>
                <div className="animated flipInY col-md-6 col-lg-5ths tile_stats_count">
                    <a href="#" className="right">
                        <div className="count">
                            {numberFormat(totalAwarded, 2, ',', '.')} €
                        </div>
                        <div className="count_top">{window.__js_dashboard.total_awarded_amount}</div>
                    </a>
                </div>
                <div className="animated flipInY col-md-6 col-lg-5ths tile_stats_count">
                    <a href="#" className="right">
                        <div className="count">
                            {avgCompletionTime}
                        </div>
                        <div className="count_top">{window.__js_dashboard.avg_completion_time}</div>
                    </a>
                </div>
                <div className="animated flipInY col-md-6 col-lg-5ths tile_stats_count">
                    <a href="#" className="right">
                        <div className="count">
                            {contractsCount}
                        </div>
                        <div className="count_top">{window.__js_dashboard.contracts_count}</div>
                    </a>
                </div>
            </div>
        );
    }
}